import css from 'styled-jsx/css';
import { display, colorHighlight, serif } from 'styles/css-constants';
import { MQ_LARGE, MQ_MEDIUM } from 'constants/mq';

export default css`
  .ProductTeaser__description :global(p) {
    font-family: ${serif};
    font-size: var(--fontScale1);
    line-height: 1.5;
    margin-bottom: 1rem;
  }

  .ProductTeaser__heading :global(h2) {
    font-family: ${display};
    font-size: var(--fontScale3);
    margin-bottom: 1rem;
  }

  .ProductTeaser__heading :global(a) {
    border-bottom: 1px solid ${colorHighlight};
    color: inherit;
  }

  .ProductTeaser :global(.Product--in-post + .ProductTeaser__heading),
  .ProductTeaser :global(.Product--in-post + .ProductTeaser__description) {
    margin-top: 2rem;
  }

  @media screen and ${MQ_MEDIUM} {
    .ProductTeaser__description :global(p) {
      font-size: var(--fontScale2);
    }
  }

  @media screen and ${MQ_LARGE} {
    .ProductTeaser__description :global(p) {
      font-size: var(--fontScale1);
    }
  }
`;
